import { gql, useMutation, useQuery } from "@apollo/client";
import cn from "classnames";
import React from "react";
import { useHistory } from "react-router-dom";
import { useMount, useTitle } from "react-use";
import investingImage from "../../../assets/images/investing.svg";
import Button from "../../../components/Button";
import { ROUTE_ONBOARDING_CONTACT } from "../../../routes";
import { Plan } from "../../../store/models/accounts";
import { StepContainer, StepHeader } from "../components/shared";

// No management fee
// Withdraw at any time.

const Plans = () => {
  const history = useHistory();
  useTitle("Onboarding - Plans | Due");
  const { data, refetch } = useQuery(gql`
    {
      onboarding {
        plan
      }
    }
  `);
  const [updateOnboarding] = useMutation(gql`
    mutation UpdateOnboarding($input: OnboardingMutationInput!) {
      onboarding(input: $input) {
        plan
      }
    }
  `);
  useMount(() => {
    refetch();
  });

  return (
    <StepContainer
      className="flex-col z-20"
      style={{ width: 700 }}
      backgroundImage={
        <img
          className="fixed bottom-10 left-10 w-5/12 z-0"
          src={investingImage}
          alt="Investing"
          style={{ transform: "scaleX(-1)" }}
        />
      }
    >
      <StepHeader className="mb-8 text-center">
        Which plan would you prefer?
      </StepHeader>
      <div className="flex w-full">
        <PlanCard
          price={"$0"}
          frequency="/month"
          title="Free Plan"
          items={[
            "1% Interest",
            "No transfer fees",
            "No management fees",
            "Full transparency",
            "Withdraw at any time",
          ]}
          className="mr-4"
          selected={
            data && data.onboarding && data.onboarding.plan === Plan.FREE
          }
          onSelectPlan={() => {
            updateOnboarding({
              variables: { input: { plan: Plan.FREE } },
            }).then(() => {
              history.push(ROUTE_ONBOARDING_CONTACT);
            });
          }}
        />
        <PlanCard
          price={"$10"}
          frequency="/month"
          title="Premium Plan"
          items={[
            "3% interest",
            "No transfer fees",
            "No management fees",
            "Full transparency",
            "Withdraw at any time",
          ]}
          className="ml-4"
          selected={
            data && data.onboarding && data.onboarding.plan === Plan.PREMIUM
          }
          onSelectPlan={() => {
            updateOnboarding({
              variables: { input: { plan: Plan.PREMIUM } },
            }).then(() => {
              history.push(ROUTE_ONBOARDING_CONTACT);
            });
          }}
        />
      </div>
    </StepContainer>
  );
};

const PlanCard = ({
  price,
  frequency,
  title,
  selected,
  items,
  className,
  onSelectPlan,
}: {
  price: string;
  frequency: string;
  title: string;
  selected: boolean;
  items: string[];
  className?: string;
  onSelectPlan: () => void;
} & React.ComponentProps<"div">) => {
  return (
    <div
      className={cn(
        "flex flex-col flex-1 p-8 border border-gray-400 rounded-md bg-white",
        "outline-none focus:outline-none focus:ring ring-primary ring-opacity-40",
        "hover:border-primary hover:ring transition-all",
        selected && "border-primary ring",
        className
      )}
      role="button"
      tabIndex={-1}
      onKeyPress={() => {
        onSelectPlan();
      }}
      onClick={() => {
        onSelectPlan();
      }}
    >
      <div className={cn("text-center text-2xl font-bold")}>{title}</div>
      <div className="mt-4">
        <span className="text-primary text-4xl font-bold">{price}</span>
        <span className="text-gray-600">{frequency}</span>
      </div>
      <div className="mt-4 flex flex-col">
        {items.map((item) => (
          <div key={item} className="text-primary mb-2">
            &bull; <span className="text-gray-600">{item}</span>
          </div>
        ))}
      </div>
      <div className="mt-6 flex justify-center">
        <Button size="lg">Select</Button>
      </div>
    </div>
  );
};

export default Plans;
